// client/src/utils/parseDiscogsData.js

import * as helpers from "./parsingDiscogsHelpers";
import { generateEbayTitle } from "./generateEbayTitle";

export function parseDiscogsData(releaseData, condition = "USED") {
  const artists = helpers.getArtists(releaseData);
  const releaseTitle = helpers.normalizeReleaseTitle(releaseData.title);
  const { label, catalogNumber } = helpers.getLabelInfo(releaseData);
  const releaseYear = helpers.getReleaseYear(releaseData);
  const format = helpers.getFormat(releaseData);
  const { genre, style } = helpers.getGenreStyle(releaseData);
  const color = helpers.getColor(releaseData);
  const allDescriptions = helpers.getAllDescriptions(releaseData);
  const features = helpers.getFeatures(releaseData, color);
  const edition = helpers.getEdition(releaseData);
  const speed = helpers.getSpeed(releaseData);
  const recordSize = helpers.getRecordSize(allDescriptions);
  const upc = helpers.getUPC(releaseData);
  const totalQty = helpers.getTotalVinylQty(releaseData);
  const type = helpers.getType(releaseData, totalQty);
  const fullDiscogsTitle = releaseData.title;
  const notesForDescription = helpers.getNotesForDescription(releaseData);
  const keySellingPoints = helpers.getKeySellingPoints(releaseData); 

  //default image
  const mainImageUrl = releaseData.images?.[0]?.uri || null;

  //hardcoded values
  const material = "Vinyl";
  const caseType = "Cardboard Sleeve";

  const editionFirst = Array.isArray(edition) ? edition[0] : edition;

  // Build eBay title
  const ebayTitle = generateEbayTitle({
    artists,
    releaseTitle,
    color,
    format,
    label,
    releaseYear,
    edition: editionFirst,
    type,
    speed,
    recordSize,
    totalQty,
    formats: releaseData.formats || [],
    series: releaseData.series || [], // ✅ this is required now!
    condition,
  });

  return {
    title: ebayTitle,
    releaseId: releaseData.id?.toString(),
    fullTitle: fullDiscogsTitle, // raw Discogs title for description
    artist: artists,
    releaseTitle,
    label,
    catalogNumber,
    releaseYear,
    format,
    genre,
    style,
    color,
    features,
    edition,
    speed,
    recordSize,
    quantity: "1",
    upc,
    material,
    type,
    caseType,
    imageUrl: mainImageUrl, // <== new line
    totalQty,
    notesForDescription,
    keySellingPoints,
  };
}
